module.exports = __webpack_public_path__ + "img/DSC_1118.dec0727c.jpg";